import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as styles from './ComparisonNotificationContainer.css';
import { trackClickPopup, trackPopupLimit } from './tracking';
import { ComparisonNotification } from '../../components/ComparisonNotification';
import { CLEAR_COMPARISON_NOTIFICATION } from '../../constants/actionTypes/offersComparison';
import { NOTIFICATION_EXPIRATION_DELAY } from '../../constants/offersComparison';
import { selectOffersComparisonNotification } from '../../selectors/offersComparison';
import { EComparisonNotificationCategory } from '../../types/offersComparion';

export const ComparisonNotificationContainer: React.FC<{}> = () => {
  const notification = useSelector(selectOffersComparisonNotification);
  const [timeoutId, setNotificationTimeout] = React.useState<ReturnType<typeof setTimeout> | null>(null);
  const dispatch = useDispatch();
  const { category, offerId, url, text } = notification || {};

  const isLimitNotification = React.useMemo(() => category === EComparisonNotificationCategory.Limit, [category]);

  React.useEffect(() => {
    if (isLimitNotification && offerId) {
      trackPopupLimit({ offerId });
    }

    setNotificationTimeout(
      setTimeout(() => {
        dispatch({
          type: CLEAR_COMPARISON_NOTIFICATION,
        });
      }, NOTIFICATION_EXPIRATION_DELAY),
    );

    return () => {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    };
  }, [notification, isLimitNotification]);

  const handleLinkClick = React.useCallback(() => {
    if (offerId && category) {
      trackClickPopup({ offerId, category });

      setNotificationTimeout(
        setTimeout(() => {
          dispatch({
            type: CLEAR_COMPARISON_NOTIFICATION,
          });
        }, NOTIFICATION_EXPIRATION_DELAY),
      );
    }
  }, [offerId, category]);

  const handleClose = React.useCallback(() => {
    dispatch({
      type: CLEAR_COMPARISON_NOTIFICATION,
    });
  }, []);

  const handleMouseEnter = React.useCallback(() => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);

  const control = url ? (
    <UIHeading5 color="white_100">
      <a href={url} className={styles['link']} onClick={handleLinkClick} target="_blank" rel="noreferrer">
        Перейти
      </a>
    </UIHeading5>
  ) : (
    <UIHeading5 color="white_100">
      <button onClick={handleClose} className={styles['button']}>
        Понятно
      </button>
    </UIHeading5>
  );

  if (text == null || text.length === 0) {
    return null;
  }

  return <ComparisonNotification onMouseEnter={handleMouseEnter} control={control} text={text} />;
};
